import { Component, Input, OnInit } from '@angular/core';
import { ModalService } from 'src/app/service/modal.service';
import { getCompareButtonCopy } from 'src/app/utils/localization';
import { LocalizationService } from 'src/app/service/localization.service';
import { JsonKey } from 'src/app/data/type/locale-copy-key';
import { AnalyticsEvent, triggerEvent } from 'src/app/utils/analytics';
import { ProgressService } from 'src/app/service/progress.service';
import { ParameterService } from 'src/app/service/parameter.service';

export enum CompareButtonLocation {
  nav = 'nav',
  endScreen = 'end-screen',
  voiceSearch = 'voice-search',
  intro = 'intro',
}

const localEvents = {
  [CompareButtonLocation.nav]: AnalyticsEvent.compareNav,
  [CompareButtonLocation.endScreen]: AnalyticsEvent.compareEndScreen,
  [CompareButtonLocation.voiceSearch]: AnalyticsEvent.compareVoiceSearch,
  [CompareButtonLocation.intro]: AnalyticsEvent.compareIntro,
};
@Component({
  selector: 'app-a02-comparison-button',
  templateUrl: './a02-comparison-button.component.html',
  styleUrls: ['./a02-comparison-button.component.scss'],
})
export class A02ComparisonButtonComponent implements OnInit {
  @Input() isBig = false;
  @Input() isSmall = false;
  @Input() isVoicePage = false;
  @Input() location: CompareButtonLocation;

  public jsonKey = JsonKey;
  public copy = {
    [JsonKey.NAVIGATION_COMPARE]: '',
  };

  public showCompareButton: boolean = this.parameterService.showCompareButton();

  constructor(
    private parameterService: ParameterService,
    private modalService: ModalService,
    private progressService: ProgressService,
    private localizationService: LocalizationService,
  ) {}

  ngOnInit(): void {
    this.copy = getCompareButtonCopy(this.localizationService);
  }

  onButtonClick() {
    this.progressService.setHasClickedComparisonButton();

    setTimeout(() => this.modalService.setIsComparisonModalVisible(true), 0);
    triggerEvent(localEvents[this.location]);
  }
}
